<template>
  <div class="home-product">
    <div :class="'inner ' + (isReverse ? 'reverse' : '')">
      <div class="left">
        <div class="title1">{{ title1 }}</div>
        <div class="title2">{{ title2 }}</div>
        <div class="desc">{{ desc }}</div>
        <div class="btn" @click="$emit('goEdit')">
          {{ $t("tryItNow") }}
          <img src="../../assets/images/icons/newhome/arrow.png" />
        </div>
      </div>
      <div class="right">
        <slot name="right"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeProduct",
  props: {
    isReverse: {
      type: Boolean,
      default: false,
    },
    title1: {
      type: String,
      default: "",
    },
    title2: {
      type: String,
      default: "",
    },
    desc: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
  beforeDestroy() {},
};
</script>

<style scoped lang="less">
.home-product {
  .inner {
    width: 1440px;
    margin: 0 auto;
    display: flex;
    min-height: 445px;
    margin-top: 80px;
    gap: 40px;
    .left {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 0 20px;
      flex: 0 0 37%;
      .title1 {
        font-size: 26px;
        font-family: GothamMedium;
        font-weight: 600;
        color: #000000;
        line-height: 29px;
        margin-bottom: 9px;
      }
      .title2 {
        font-size: 38px;
        color: #000000;
        line-height: 38px;
        margin-bottom: 15px;
        font-weight: 600;
      }
      .desc {
        font-size: 18px;
        font-family: GothamMedium;
        font-weight: 500;
        color: #999999;
        margin-bottom: 50px;
      }
      .btn {
        font-size: 18px;
        font-family: GothamMedium;
        font-weight: 600;
        color: #8873ff;
        cursor: pointer;
        transition: all 0.15s;
        display: flex;
        align-items: center;
        &:hover {
          opacity: 0.85;
        }
        img {
          height: 26px;
        }
      }
    }
    .right {
      padding: 0 20px;
      flex: 0 0 63%;
      position: relative;
      img {
        height: 100%;
      }
    }
    &.reverse {
      flex-direction: row-reverse;
    }
  }
}

/* 小于等于1440px时应用的样式 */
@media (max-width: 1440px) {
  .home-product {
    .inner {
      width: 1200px;
    }
  }
  .home-product .inner .left .desc {
    font-size: 16px;
  }
}
</style>
